import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from '../../store';
import axios from "axios";
import { required, maxLength, minValue } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Select2Multiple from "v-select2-multiple-component";
import CONFIG from "@/assets/js/config.js";
import { blockSpecialChars } from '@/utils/validators';

export default {
  name: "PaymentAttributeEdit",

  components: { MainLayout, Loading,Select2Multiple},

  data() {
    return {
      noDataMsg : 'No Data Found',
      isLoading: false,
      disabled: false,
      paymentAttributeData: {},

      attribute_name: '',
      category_id: null,
      type: null,
      order: null,
      description: '',
      is_active: null,

      submitted: false,
      STATUS: CONFIG.STATUS,
      CATEGORIES: CONFIG.CATEGORIES,
      TYPES: CONFIG.TYPES
    };
  },

  validations: {
    attribute_name: { required, maxLength: maxLength(255) },
    category_id: { required },
    type: { required },
    order: { required, minValue: minValue(1) },
    description: { maxLength: maxLength(1000) },
    is_active: { required }
  },

  methods: {
    handleKeyDown(event) {
      blockSpecialChars(event);
    },
    getPaymentAttribute() {
      this.isLoading = true;
      const id = this.$route.params.id;

      axios.get(`/paymentAttribute/detail/${id}`)
        .then(response => {
          const data = response.data;
          this.paymentAttributeData = data;

          if (data) {
            this.attribute_name = data.attribute_name || '';
            this.category_id = data.category_id || '';
            this.type = data.type || '';
            this.order = data.order;
            this.description = data.description || '';
            this.is_active = Number(data.is_active);
          }
        })
        .catch(error => {
          if (error.response?.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error("Payment Attribute Detail API Error", error);
          }
        })
        .finally(() => { this.isLoading = false; });
    },

    confirmUpdate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.update();
    },

    update() {
      this.disabled = true;
      const id = this.$route.params.id;

      const request = {
        attribute_name: this.attribute_name,
        category_id: typeof this.category_id === 'object' ? this.category_id?.id : this.category_id,
        type: typeof this.type === 'object' ? this.type?.id : this.type,
        order: this.order,
        description: this.description,
        is_active: this.is_active,
        updated_id: store.state.user.id,
      };

      axios.post(`/paymentAttribute/update/${id}`, request)
        .then(() => {
          this.$notification.success("Payment Attribute Updated Successfully", {
            timer: 3, position: "bottomCenter"
          });
          this.$router.push({ name: "paymentAttributeList" });
        })
        .catch(error => {
          this.disabled = false;
          if (error.response?.status === 422) {
            this.$notification.error(error.response.data.message, {
              timer: 3,
              position: "bottomCenter"
            })
          } else if (error.response?.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else if (error.response?.status === 403) {
              this.$notification.error(error.response.data.message, {
              timer: 3,
              position: "bottomCenter"
            })
          } else {
            console.error("Unexpected error:", error);
          }
        });
    },

    showList() {
      this.$router.push({ name: "paymentAttributeList" });
    }
  },

  mounted() {
    this.getPaymentAttribute();
  }
};
